import React, { useEffect, useState } from "react";
// javascript plugin used to create scrollbars on windows
//import PerfectScrollbar from "perfect-scrollbar";
import { Route, Switch } from "react-router-dom";

import DemoNavbar from "components/Navbars/DemoNavbar.js";
import Sidebar from "components/Sidebar/Sidebar.js";
//import FixedPlugin from "components/FixedPlugin/FixedPlugin.js";
import template from "views/template.js";
import events from "views/Events";
import api from "services/api";
import _ from "lodash";
import { jwtDecode } from "jwt-decode";
import moment from "moment";
import { msalConfig } from "authetication/authConfig";
import { PublicClientApplication } from "@azure/msal-browser";
const { v4: generateId } = require("uuid");

//import routes from "routes.js";

//var ps;

function Dashboard(props) {
  const [backgroundColor] = useState("black");
  const [activeColor] = useState("info");
  const [routes, setRoutes] = useState([]);
  const [loading, setLoading] = useState(false);
  const [sidebarMini, setSidebarMini] = React.useState(false);
  const mainPanel = React.createRef();
  const msalInstance = new PublicClientApplication(msalConfig);
  useEffect(() => {
    getMenus();
    if (navigator.platform.indexOf("Win") > -1) {
      //var ps = new PerfectScrollbar(mainPanel.current);
      document.body.classList.toggle("perfect-scrollbar-on");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    const tokenExpirado = async () => {
      const token = localStorage.getItem("teste");
      if (!token) {
        return true;
      }

      try {
        const decodedToken = jwtDecode(token);
        const currentTime = Date.now() / 1000;

        const expirationTimeBuffer = 5 * 60;
        if (decodedToken.exp - currentTime <= expirationTimeBuffer) {
          console.log("Token próximo de expirar, tentando renovar...");

          try {
            const account = msalInstance.getActiveAccount();
            if (account) {
              const tokenResponse = await msalInstance.acquireTokenSilent({
                scopes: ["User.Read"],
                account: account,
              });

              if (tokenResponse && tokenResponse.accessToken) {
                console.log("Token atualizado com sucesso:", tokenResponse);
                localStorage.setItem("teste", tokenResponse.accessToken);
              } else {
                console.log(
                  "Falha ao obter um novo token, redirecionando para login..."
                );
                localStorage.removeItem("msal.interaction.status");
                msalInstance.logoutRedirect({
                  postLogoutRedirectUri: "/",
                });
              }
            }
          } catch (error) {
            // console.error("Erro ao tentar renovar o token:", error);
            // localStorage.removeItem("msal.interaction.status");
            // msalInstance.logoutRedirect({
            //   postLogoutRedirectUri: "/",
            // });
          }
        } else {
          console.log(
            "Data de expiração:",
            moment(decodedToken.exp * 1000).format("YYYY-MM-DD HH:mm:ss")
          );
          console.log(
            "Hora atual:",
            moment(currentTime * 1000).format("YYYY-MM-DD HH:mm:ss")
          );
        }
      } catch (error) {
        console.log("Erro ao decodificar o token:", error);
        localStorage.clear();
        sessionStorage.clear();
        localStorage.removeItem("msal.interaction.status");
        msalInstance.logoutRedirect({
          postLogoutRedirectUri: "/",
        });
      }
    };

    const intervalId = setInterval(tokenExpirado, 60000);

    tokenExpirado();

    return () => clearInterval(intervalId);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const filterSlice = (array, position) => {
    // eslint-disable-next-line array-callback-return
    return array.filter((item) => {
      let index = array.findIndex((index) => index === item);
      if (index < position) return item;
    });
  };

  const getPai = (nomePai, array, raiz, menu) => {
    if (raiz) {
      let teste = array.find(
        (item) =>
          item.menu.trim().replaceAll(" ", "").toUpperCase() ===
            nomePai.trim().replaceAll(" ", "").toUpperCase() &&
          item?.area === menu?.area
      );
      return teste;
    } else {
      let teste = array.views.find(
        (item) =>
          item.menu.trim().replaceAll(" ", "").toUpperCase() ===
          nomePai.trim().replaceAll(" ", "").toUpperCase()
      );
      return teste;
    }
  };

  const getMenus = () => {
    try {
      setLoading(true);
      let header = {
        Authorization: "bearer " + localStorage.getItem("teste"),
      };
      api.get("getMenu", header, function (status, data) {
        if (status === 200) {
          localStorage.setItem("menus", JSON.stringify(data));
          const url = window.location.pathname;
          const idMenu = url.split("/").at(-1);
          const menu = data.find((x) => x.id === Number(idMenu));
          localStorage.setItem("menu_nome", menu?.nome);
          localStorage.setItem("menu_completo", menu?.menu);

          let routest = [];
          setLoading(false);
          data = _.sortBy(
            data.map((item) => {
              item.countMenu = item.menu.split("|").length - 1;
              item.menuSplit = item.menu.split("|");
              item.position = item.menu.split("|").length - 1;
              return item;
            }),
            [
              function (o) {
                return o.countMenu;
              },
            ]
          );
          let listadd = [];
          for (let menu of data) {
            if (menu.countMenu > 0) {
              let position = 0;
              let menuAnterior = "";
              for (let split of menu.menuSplit) {
                if (position !== menu.countMenu) {
                  let teste = data.find(
                    // eslint-disable-next-line no-loop-func
                    (item) =>
                      (item.menu.trim().replaceAll(" ", "").toUpperCase() ===
                        split.trim().replaceAll(" ", "").toUpperCase() ||
                        item.menu.trim().replaceAll(" ", "").toUpperCase() ===
                          menuAnterior
                            .trim()
                            .replaceAll(" ", "")
                            .toUpperCase() +
                            "|" +
                            split.trim().replaceAll(" ", "").toUpperCase()) &&
                      (item.position === position || position === 0)
                  );
                  if (!teste) {
                    teste = listadd.find(
                      // eslint-disable-next-line no-loop-func
                      (item) =>
                        item.menu.trim().replaceAll(" ", "").toUpperCase() ===
                          split.trim().replaceAll(" ", "").toUpperCase() &&
                        (item.menuAnterior === menuAnterior || !menuAnterior) &&
                        (item.position === position || position === 0)
                    );
                    if (!teste) {
                      let menusAnteriores = filterSlice(
                        menu.menuSplit,
                        position
                      );
                      listadd.push({
                        area: menu.area,
                        menu: split,
                        position: position,
                        notMenu: true,
                        tipo: menu.tipo,
                        menuAnterior:
                          position > 0 ? menu.menuSplit[position - 1] : null,
                        menusAnteriores: menusAnteriores,
                      });
                    }
                  }
                  menuAnterior =
                    position === 0
                      ? split
                      : menuAnterior.trim().replaceAll(" ", "") +
                        "|" +
                        split.trim().replaceAll(" ", "");
                  position = position + 1;
                }
              }
            }
          }
          var result = [];
          result = listadd.filter(
            (value, index, self) =>
              index ===
              self.findIndex(
                (t) =>
                  t.menu === value.menu &&
                  JSON.stringify(t.menusAnteriores) ===
                    JSON.stringify(value.menusAnteriores)
              )
          );
          data.push(...result);
          let notMenus = _.sortBy(
            data.filter((info) => info.notMenu),
            [
              function (o) {
                return o.position;
              },
            ]
          );
          let menus = _.sortBy(
            data.filter((info) => !info.notMenu),
            [
              function (o) {
                return o.position;
              },
            ]
          );
          for (let menuCreate of menus) {
            if (menuCreate.position === 0) {
              routest.push(createMenu(menuCreate));
              routest = _.sortBy(routest, [
                function (o) {
                  return o.ordem;
                },
              ]);
            }
          }

          for (let item of notMenus) {
            if (item.position === 0) {
              routest.push(
                createMenuAnterior(
                  item.area,
                  item.menu,
                  item.position,
                  item.ordem,
                  item.tipo
                )
              );
              routest = _.sortBy(routest, [
                function (o) {
                  return o.ordem;
                },
              ]);
            }
          }
          // Itens reais e sintéticos precisam ser anexados intercalados por
          // posição: um sintético pode ter pai real e vice-versa
          let pendentes = _.sortBy(
            [
              ...notMenus.filter((item) => item.position > 0),
              ...menus.filter((item) => item.position > 0),
            ],
            [
              function (o) {
                return o.position;
              },
            ]
          );
          for (let item of pendentes) {
            let menusAnteriores = item.notMenu
              ? item.menusAnteriores
              : item.menuSplit.slice(0, item.menuSplit.length - 1);
            let menuPai = routest;
            let raiz = true;
            for (let i = 0; i < menusAnteriores.length; i++) {
              if (!menuPai) {
                break;
              }
              let aux = getPai(menusAnteriores[i], menuPai, raiz, item);
              menuPai = aux ? aux : null;
              raiz = false;
            }
            if (menuPai) {
              menuPai.views.push(
                item.notMenu
                  ? createMenuAnterior(
                      item.area,
                      item.menu,
                      item.position + 1,
                      item.ordem,
                      item.tipo
                    )
                  : createMenu(item)
              );
              menuPai.views = _.sortBy(menuPai.views, [
                function (o) {
                  return o.ordem;
                },
              ]);
            }
          }

          setRoutes(routest);
          localStorage.setItem("menuHierarquia", JSON.stringify(routest));
          console.log("routest:", "entrou ");
        }
      });
    } catch (ex) {
      console.log("ex:", ex);
    }
  };

  const createMenu = (menu) => {
    let menuCriado = {
      path: `/${menu.area}/${menu.menuSplit[menu.countMenu]}/${menu.id}`,
      menu: menu.menuSplit[menu.countMenu],
      name: menu.menuSplit[menu.countMenu],
      icon: "",
      component: menu.tipo === "2" ? events : template,
      layout: "/admin",
      area: menu.area,
      collapse: false,
      state: "componentsCollapse" + menu.id?.toString(),
      position: menu.position + 1,
      views: [],
      menuCompleto: menu.menu,
      menuSplit: menu.menuSplit,
      countMenu: menu.countMenu,
      ordem: menu.ordem,
      idMenu: menu.id?.toString(),
    };
    return menuCriado;
  };

  const createMenuAnterior = (area, nome, position, ordem, tipo) => {
    let menuCriado = {
      path: ``,
      menu: nome,
      name: nome,
      icon: "",
      component: tipo === "2" ? events : template,
      layout: "/admin",
      area: area,
      collapse: true,
      state: "componentsCollapse" + generateId(),
      position: position,
      views: [],
      menuCompleto: "",
      ordem: ordem,
    };
    return menuCriado;
  };
  const getRoutes = (routes) => {
    return routes.flatMap((prop, key) => {
      let routeItems = [];
      if (prop.views?.length > 0) {
        // Acrescenta as rotas retornadas pela chamada recursiva ao array de rotas
        routeItems.push(...getRoutes(prop.views));
      }
      if (prop.layout === "/admin") {
        // Acrescenta a rota atual ao array de rotas
        routeItems.push(
          <Route
            path={prop.layout + prop.path}
            component={prop.component}
            key={key}
          />
        );
      }
      return routeItems; // Retorna todos os itens de rota acumulados
    });
  };

  const handleMiniClick = () => {
    if (document.body.classList.contains("sidebar-mini")) {
      setSidebarMini(false);
    } else {
      setSidebarMini(true);
    }
    document.body.classList.toggle("sidebar-mini");
  };

  return (
    <div className="wrapper">
      <Sidebar
        {...props}
        routes={routes}
        bgColor={backgroundColor}
        activeColor={activeColor}
        loading={loading}
      />
      <div className="main-panel" ref={mainPanel}>
        <DemoNavbar
          {...props}
          sidebarMini={sidebarMini}
          handleMiniClick={handleMiniClick}
        />
        <Switch>{getRoutes(routes)}</Switch>
        {/* <Switch>
            {routes.map((prop, key) => {
              return (
                <Route
                  path='admin/Econômico/%20Setor%20Externo/417'
                  component={template}
                  key={key}
                />
              )
            })}
          </Switch> */}
        {/* <Footer fluid /> */}
      </div>
      {/*  <FixedPlugin
          bgColor={this.state.backgroundColor}
          activeColor={this.state.activeColor}
          handleActiveClick={this.handleActiveClick}
          handleBgClick={this.handleBgClick}
        /> */}
    </div>
  );
}

export default Dashboard;
